<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Alarmed Delivered Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Alarmed Delivered Report",
      items: [
        {
          text: "Home",
        },
         {
          text: "Reports",
        },
        {
          text: "Alarmed Delivered Report",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>